


















































import { Mixins, Component } from "vue-property-decorator"
import PageHeader from "@/components/page-header/index.vue"
import { getColumns } from "./constant"
import PageMixin from "@/mixins/page"
import CdnEdit from "./edit.vue"
import channelService from "@/services/channel.service"
import { omit } from "lodash"

@Component({
    components: {
        PageHeader,
        CdnEdit
    }
})
export default class CdnDomainName extends Mixins(PageMixin) {
    visible = false
    dataSource: any = []
    lineData: any = {}
    fromType = "add"
    loading = false
    pagination = {
        current: 1,
        pageSize: 10,
        showQuickJumper: true,
        showSizeChanger: true,
        showLessItems: true,
        size: "normal",
        total: 0,
        pageSizeOptions: ["10", "20", "30", "40", "100"],
        get limit() {
            return this.pageSize
        },
        get offset() {
            return (this.current - 1) * this.pageSize
        },
        onChange: (page: number, pageSize: number) => {
            this.pagination.pageSize = pageSize
            this.pagination.current = page
            this.getList()
        },
        onShowSizeChange: (current: number, size: number) => {
            this.pagination.pageSize = size
            this.pagination.current = 1
            this.getList()
        }
    }

    get columns() {
        return getColumns
    }

    get tableActions() {
        return () => {
            const actions = [
                {
                    title: "编辑",
                    event: "edit"
                }
            ]

            return actions
        }
    }
    get vPaginationBinds() {
        const exclude = ["limit", "offset", "showTotal", "onChange", "onShowSizeChange"]
        return omit(this.pagination, exclude)
    }
    created() {
        this.getList()
    }
    addCdn() {
        this.fromType = "add"
        this.visible = true
    }
    onDispatch(record: any) {
        this.fromType = "edit"
        this.lineData = record.payload
        this.visible = true
    }

    async getList() {
        const offset = (this.pagination.current - 1) * this.pagination.pageSize
        const limit = this.pagination.pageSize
        const payload: any = {
            offset,
            limit
        }
        this.loading = true
        try {
            const res = await channelService.getCdnList(payload)
            const { total, List } = res
            this.dataSource = List || []
            this.pagination.total = total
        } catch (error) {
            if (error) {
                this.$message.error(`获取数据失败！ ${error}`)
            }
        } finally {
            this.loading = false
        }
    }
}
